// Centralized configuration for API and asset URLs
// In production (same origin), use relative paths. In development, point to the backend server.

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
// Respect an intentionally empty SERVER_URL (used in production for same-origin assets)
export const SERVER_URL = process.env.REACT_APP_SERVER_URL ?? '';
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5001';

/**
 * Get full URL for a server-hosted asset (e.g. profile image, uploaded file)
 * In production, assets are served from the same origin so just the path is needed.
 * In development, we prepend the dev server URL.
 */
export const getAssetUrl = (path) => {
  if (!path) return '';
  // If already a full URL, return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${SERVER_URL}${path}`;
};
